import { editableCellsConfig } from "../FlotteTable/editableCells.config";
import { rmeFieldConfigs } from "./rmeTableUtils";

export const mouvementOptions = [
  { id: "contrat", name: "Contrat", color: "#2E7D32" },
  { id: "prolongation", name: "Prolong.", color: "#b27b12" },
  { id: "fin_reelle", name: "Fin réelle", color: "#12b2ab" },
  { id: "simulation", name: "Simulation", color: "#909090" },
  {
    id: "simulation_prorata_km",
    name: "Simulation km 🔁",
    color: "#909090",
  },
];

export const getMouvementColorFromName = (name) => {
  const option = mouvementOptions.find((option) => option.name === name);
  return option ? option.color : "#909090";
};

// Groupes d'affichage de colonnes du tableau flotte (LS-636), cumulables entre eux
// en plus du groupe "default" (toujours actif, sans bouton dédié).
export const groupOptions = [
  { id: "contrat", name: "Contrat", color: "#2E7D32" },
  { id: "bb", name: "BB", color: "#C2185B" },
  { id: "vo", name: "VO", color: "#F57C00" },
];

export const getGroupColorFromId = (id) => {
  const option = groupOptions.find((option) => option.id === id);
  return option ? option.color : "#909090";
};

export const fieldConfigs = {
  mouvement: {
    label: "Type de mouvement",
    title: "Mouvement",
    type: "select",
    options: mouvementOptions,
    order: 0,
    formatter: (value) => value,
  },
  date: {
    label: "Date de retour",
    title: "Date retour",
    type: "date",
    order: 1,
    formatter: (value) => new Date(value).toLocaleDateString("fr-FR"),
  },
  duree: {
    label: "Durée (en mois)",
    title: "Durée (mois)",
    type: "number",
    props: { min: 1 },
    order: 2,
    formatter: (value) => `${value} mois`,
  },
  kilometrage: {
    label: "Kilométrage",
    title: "km",
    type: "number",
    props: { min: 0 },
    style: { minWidth: 120 },
    order: 3,
    formatter: (value) => `${Number(value).toLocaleString()} km`,
  },
  taux_vr: {
    label: "Taux VR",
    title: "Taux VR",
    type: "number",
    props: { min: 0, max: 100, step: 0.1 },
    order: 4,
    formatter: (value) => Number(value).toLocaleString(),
  },
  montant_vr: {
    label: "Montant VR HT",
    title: "Montant VR HT",
    type: "number",
    props: { min: 0, step: 0.01 },
    order: 5,
    formatter: (value) => `${Number(value).toFixed(2)} €`, //must be truncated to 2 decimals
  },
  valeur_theorique: {
    label: "Valeur théorique HT",
    title: "Valeur théorique HT",
    type: "number",
    props: { min: 0, step: 0.01 },
    order: 6,
    formatter: (value) => `${Number(value).toFixed(2)} €`, //must be truncated to 2 decimals
  },
  indemnites: {
    label: "Indemnités HT",
    title: "Indemnités HT (projetées)",
    type: "number",
    props: { min: 0, step: 0.01 },
    order: 7,
    readOnly: true,
    formatter: (value) => `${Number(value).toFixed(2)} €`, //must be truncated to 2 decimals
  },
  montant_kilometres_supplementaires: {
    label: "Kilomètre supplémentaire HT",
    title: "Km sup. HT (projeté)",
    type: "number",
    props: { min: 0, step: 0.01 },
    order: 8,
    readOnly: true,
    formatter: (value) => `${Number(value).toFixed(2)} €`, //must be truncated to 2 decimals
  },
  // cout_remise_en_etat_facture: {
  //   label: "Coût facturé HT",
  //   title: "Coût facturé HT",
  //   type: "number",
  //   props: { min: 0, step: 0.01 },
  //   order: 11,
  //   disabledMouvements: ["contrat", "prolongation"],
  //   formatter: (value) => `${Number(value).toFixed(2)} €`, //must be truncated to 2 decimals
  // },
};

export const getFieldConfig = (field) => {
  return (
    fieldConfigs[field] ||
    rmeFieldConfigs[field] || { label: field, type: "text" }
  );
};

export const getEditableCellConfig = (field) => {
  return editableCellsConfig[field] || { label: field, type: "text" };
};

// Fonction pour obtenir les colonnes éditables triées par ordre
export const getEditableColumns = () => {
  // Exclure la colonne 'mouvement' qui n'est pas éditable dans le tableau
  const editableFields = Object.keys(fieldConfigs).filter(
    (field) => field !== "mouvement",
  );

  return editableFields
    .map((field) => ({
      field,
      title: fieldConfigs[field].title,
      style: fieldConfigs[field].style,
    }))
    .sort((a, b) => fieldConfigs[a.field].order - fieldConfigs[b.field].order);
};

export const getProjections = (item) => {
  const projections = item.mouvements
    .filter((mouvement) => mouvement.type !== "vente")
    .map((mouvement) => {
      return {
        ...mouvement,
        mouvement: mouvement.type,
      };
    });
  /*
    On doit aller vérifier dans les informations si le véhicule possède les informations suivantes :
    - Une date de prolongation
    - Une date de fin réelle
    - Une date de vente
    - Une simulation de vente

    Pour chacune de ces infos, il faut créer les projections correspondantes.
    en allant chercher la data au bon endroit dans item.
    */
  return projections;
};

// Fonction pour formater l'affichage des valeurs
export const formatDisplayValue = (field, value, isEditableCell = false) => {
  if (value === null || value === undefined || value === "") return "---";
  let configRef = isEditableCell ? editableCellsConfig : fieldConfigs;
  const fieldConfig = configRef[field] || rmeFieldConfigs[field];
  if (fieldConfig && fieldConfig.formatter) {
    return fieldConfig.formatter(value);
  }

  return value;
};
